import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MapModule } from '../../map';
import { ReservationStagiaireComponent } from './reservationstagiaire.component';
import { GetHourReservationStagiairePipe, GetDateReservationStagiairePipe } from './reservationstagiaire.pipe';
import { DynamicTagGroupModule } from '../../bodisplay';
import { PipeModule } from '../../pipes';
import { SignatureModule } from '../../signature';

@NgModule({
  declarations: [
    ReservationStagiaireComponent,
    GetHourReservationStagiairePipe,
    GetDateReservationStagiairePipe
  ],
  exports: [ReservationStagiaireComponent],

  imports: [
    CommonModule,
    PipeModule,
    FormsModule,
    MapModule,
    DynamicTagGroupModule,
    SignatureModule

  ]
})

export class ReservationStagiaireModule { }
